<template>
    <div style="height:100%;width: 100%;">
        <div class="device-pc" style="width:100%;height:100%;background:rgba(250, 250, 250, 1);overflow: hidden;padding: 70px 0 24px;position: relative;">
            <div style="position: absolute;width: 100%;height: 50px;text-align: center;background:#fff;left:0px;top:0px;border-bottom: 1px solid rgba(229, 229, 229, 1);">
                <div style="width:100%;height:100%;position:relative;">
                    <img style="width:137px;position:absolute;top:6px;left:32px;" src="./../assets/img/pro-logo.png" alt="">
                    <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;line-height: 50px;line-height:50px">{{biographicalDetail.name}}</span>
                    <div style="position:absolute;right:32px;display:inline-block;top:0px;">
                        <!-- <span @click="shareModal" style="display:inline-block;width:80px;height:32px;line-height:30px;border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 0.08);border-radius:4px;color:rgba(34, 215, 187, 1);font-size:14px;cursor:pointer;margin-left:44px;margin-top:10px;">分享</span> -->
                    </div>
                </div>
            </div>
            <div style="height:100%;overflow-y:auto;">
                <div style="width: 1200px;margin: 0 auto;">
                    <div style="padding:16px 24px;border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;background: #fff;">
                        <div style="color:rgba(18, 18, 18, 1);font-size: 18px;font-weight:bold;">基本信息</div>
                        <div style="display: flex;margin-top: 23px;box-shadow: rgba(158, 172, 196, 0.16) solid 3px;text-align: center;">
                            <div style="width: 64px;background: rgba(222, 213, 254, 1);border: 1px solid rgba(158, 172, 196, 0.16);height: 93px;">
                                <img style="width: 56px;margin-top:12px" :src="biographicalDetail.avatar" alt="">
                            </div>
                            <div style="flex:1">
                                <a-row class="basic-info">
                                    <a-col :span="12" v-for="(item,index) in biographicalDetail.baseInfo" :key="index" style="padding-left:40px;">
                                        <div class="info-list">
                                            <span class="info-title">{{item.question}}：</span>
                                            <span class="info-content">{{item.answer}}</span>
                                        </div>
                                    </a-col>
                                </a-row>
                            </div>
                        </div>
                    </div>
                    <div style="padding:16px 12px 16px 24px;border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;background: #fff;margin-top: 16px;" class="job-duty">
                        <div style="color:rgba(18, 18, 18, 1);font-size: 18px;font-weight:bold;">工作职责</div>
                        <div style="display: flex;margin-top: 17px;" class="job-content">
                            <div style="flex: 1;height: 50px;">
                                <div>{{ biographicalDetail.responsibility.answer }}</div>
                            </div>
                        </div>
                    </div>
                    <div style="padding:16px 12px 16px 24px;border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;background: #fff;margin-top: 16px;" class="bg-info">
                        <div style="color:rgba(18, 18, 18, 1);font-size: 18px;font-weight:bold;margin-bottom: 16px;">背景信息</div>
                        <div v-for="(item,index) in biographicalDetail.background" :key="index">
                            <div class="bg-list" style="display: flex;min-height: 77px;margin-bottom: 7px;" v-if="item.answer!=''">
                                <div style="background: rgba(244, 244, 245, 0.5);border-radius: 8px;padding: 5px 8px 0 12px;flex: 1;">
                                    <div style="min-height:32px;display:flex;">
                                        <span style="display: inline-block;width:20px;height: 20px;border-radius: 5px;background: rgba(34, 215, 187, 1);margin-right:8px;text-align:center;line-height:20px;margin-top:7px">
                                            <a-icon style="color:#fff;font-size:12px;" type="search" />
                                        </span>
                                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;margin-top:7px;flex:1">{{ item.question }}</span>
                                    </div>
                                    <div style="min-height:32px;display:flex;margin-top:2px">
                                        <span style="display: inline-block;width:20px;height: 20px;border-radius: 5px;background: rgba(42, 130, 228, 1);margin-right:8px;text-align:center;line-height:20px;margin-top:7px;color:#fff">
                                            A
                                        </span>
                                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;margin-top:7px;flex:1">{{ item.answer }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding:16px 12px 16px 24px;border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;background: #fff;margin-top: 16px;" class="extra-require">
                        <div style="color:rgba(18, 18, 18, 1);font-size: 18px;font-weight:bold;margin-bottom: 16px;">补充要求</div>
                        <div class="extra-list" style="display: flex;min-height: 34px;margin-bottom: 7px;line-height:34px;" v-for="(item,index) in biographicalDetail.supplement" :key="index">
                            <img style="width:16px;margin-right:8px;margin-top:3px" src="../assets/img/extra-icon.svg" alt="">
                            <div style="background: rgba(244, 244, 245, 0.5);border-radius: 8px;padding: 1px 2px;flex: 1;">
                                <span style="color:rgba(0, 0, 0, 1);font-size:13px;margin-top:7px;">{{ item.answer }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display:inline-block;width:52px;position:absolute;right:28px;bottom:48px;">
                <div @click="showChat" style="height:52px;border-radius:26px;cursor:pointer;background:rgba(42, 130, 228, 1);box-shadow:0px 3px 20px 0px rgba(42, 130, 228, 0.24);text-align:center;line-height:60px;">
                    <a-icon style="font-size:24px;color:rgba(255, 255, 255, 1);" type="message" />
                </div>
                <div style="text-align:center;color:rgba(18, 18, 18, 1);font-size:13px;margin-top:8px;">对话测试</div>
            </div>
            <div v-if="jumpSource=='view'" style="display:inline-block;width:52px;position:absolute;right:28px;bottom:48px;">
                <div @click="showChat" style="height:52px;border-radius:26px;cursor:pointer;background:rgba(42, 130, 228, 1);box-shadow:0px 3px 20px 0px rgba(42, 130, 228, 0.24);text-align:center;line-height:60px;">
                    <a-icon style="font-size:24px;color:rgba(255, 255, 255, 1);" type="message" />
                </div>
                <div style="text-align:center;color:rgba(18, 18, 18, 1);font-size:13px;margin-top:8px;">对话测试</div>
            </div>
            <div v-if="ifShowChat" style="width:600px;height:560px;box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);position:absolute;right:0px;bottom:0px;background:rgba(255, 255, 255, 1);display:flex;flex-direction:column;border-radius:8px;overflow:hidden;padding-bottom:8px;">
                <div style="height:48px;line-height:48px;background:rgba(238, 238, 238, 1);padding:0 16px 0 24px">
                    <span style="color:rgba(51, 51, 51, 1);font-size:16px;">对话</span>
                    <a-icon @click="closeChat" type="close" style="float:right;margin:15px 0 0 0;font-size:16px;color:rgba(80, 80, 80, 1);cursor:pointer;" />
                </div>
                <div style="flex:1;overflow-y:auto;padding:0 12px 12px;" id="chatBody">
                    <div v-for="(item,index) in chatData" :key="index">
                        <div class="chat-gpt" v-if="item.question!=''">
                            <img style="width:32px;border-radius:10px;height:32px;" src="./../assets/img/step-avator.png" alt="">
                            <div style="flex:1;margin:0 8px;border:1px solid rgba(229, 231, 235, 1);background:rgba(244, 244, 245, 0.5);border-radius:8px;color:rgba(18, 18, 18, 1);font-size:13px;padding:8px;word-break:break-all">
                                {{item.question}}
                            </div>
                            <a-icon v-if="!item.ifPlay" @click="tryListen(item.question,index)" style="color:rgba(34, 215, 187, 1);font-size:18px;cursor:pointer;position:absolute;right:-24px;top:50%;margin-top:-10px;" type="play-circle" />
                            <a-icon v-if="item.ifPlay" style="color:rgba(34, 215, 187, 1);font-size:18px;cursor:pointer;position:absolute;right:-24px;top:50%;margin-top:-10px;" type="pause-circle" />
                        </div>
                        <span v-if="item.question==''" class="chat-loading">
                            <a-icon class="gpt-icon" type="loading" />正在输入中...
                        </span>
                        <div style="clear:both;"></div>
                        <div class="chat-user" v-if="item.answer!=''">
                            {{item.answer}}
                        </div>
                        <div style="clear:both"></div>
                    </div>
                    <div v-if="tryBiographicalBool" class="chat-error" style="margin-top:12px;">
                        <span @click="sendDataToBiographical" style="color:rgba(42, 130, 228, 1);cursor:pointer;margin-left:40px;text-decoration:underline">太慢啦，快些输入吧</span>
                    </div>
                </div>
                <div style="height:108px;padding:0 8px;position:relative;">
                    <a-textarea @keyup.enter="chatToBiographical(1)" :disabled="disabledBiographical" v-model="biographicalData" placeholder="请输入回答" style="resize: none;height:108px;border:1px solid rgba(229, 231, 235, 1);"  ref="binput" />
                    <span @click="chatToBiographical(1)" style="position:absolute;right:16px;bottom:8px;cursor:pointer;width:52px;height:32px;display:inline-block;text-align:center;line-height:32px;color:#fff;font-size:14px;z-index:1000;background:rgba(34, 215, 187, 1);border-radius:6px;">发送</span>
                </div>
            </div>
        </div>
        <div class="device-phone" v-if="!chatStylePhone" style="width:100%;height:100%;background:rgba(250, 250, 250, 1);position: relative;">
            <div style="height:52px;background:#fff;padding:12px 16px;">
                <img style="width:28px;float:left;" src="../assets/img/chat-head.png" alt="">
                <span style="color:rgba(18, 18, 18, 1);font-size:16px;margin-left:8px;float:left;margin-top:2px;">{{biographicalDetail.name}}</span>
            </div>
            <div style="padding:16px;background:#fff;margin-top:8px;">
                <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">基本信息</div>
                <div style="display:flex;margin-top:16px;">
                    <div style="flex:1">
                        <div style="display:flex;margin-bottom:8px;" v-for="(item,index) in biographicalDetail.baseInfo" :key="index">
                            <div style="display:inline-block;width:75px;color:rgba(158, 172, 196, 1);font-size:14px;">{{item.question}}：</div>
                            <div style="padding-left:12px;color:rgba(0, 0, 0, 1);font-size:14px;flex:1">{{item.answer}}</div>
                        </div>
                    </div>
                    <div style="width:75px;height:108px;display:inline-block;background:rgba(222, 213, 254, 1);margin-left:17px;">
                        <img style="width:75px;margin-top:15px;" :src="biographicalDetail.avatar" alt="">
                    </div>
                </div>
            </div>
            <div style="padding:16px;background:#fff;margin-top:8px;">
                <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">工作职责</div>
                <div style="color:rgba(48, 48, 48, 1);font-size:14px;margin-top:16px;">{{biographicalDetail.responsibility.answer}}</div>
            </div>
            <div style="padding:16px;background:#fff;margin-top:8px;">
                <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;margin-bottom:4px;">背景信息</div>
                <div v-for="(item,index) in biographicalDetail.background" :key="index">
                    <div style="padding:12px;background:rgba(244, 244, 245, 0.5);margin-top:8px;border-radius:8px;" v-if="item.answer!=''">
                        <div style="min-height:32px;display:flex;">
                            <span style="display: inline-block;width:20px;height: 20px;border-radius: 5px;background: rgba(34, 215, 187, 1);margin-right:8px;text-align:center;line-height:20px;margin-top:7px">
                                <a-icon style="color:#fff;font-size:12px;" type="search" />
                            </span>
                            <span style="color:rgba(0, 0, 0, 1);font-size:13px;margin-top:7px;flex:1">{{item.question}}</span>
                        </div>
                        <div style="min-height:32px;display:flex;margin-top:2px">
                            <span style="display: inline-block;width:20px;height: 20px;border-radius: 5px;background: rgba(42, 130, 228, 1);margin-right:8px;text-align:center;line-height:20px;margin-top:7px;color:#fff">
                                A
                            </span>
                            <span style="color:rgba(0, 0, 0, 1);font-size:13px;margin-top:7px;flex:1">{{item.answer}}</span>
                        </div>
                    </div>
                </div>
                
            </div>
            <div style="padding:16px;background:#fff;margin-top:8px;">
                <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;margin-bottom:4px;">补充要求</div>
                <div class="extra-list" style="display: flex;min-height: 34px;margin-bottom: 8px;line-height:34px;" v-for="(item,index) in biographicalDetail.supplement" :key="index">
                    <img style="width:16px;margin-right:8px;margin-top:3px" src="../assets/img/extra-icon.svg" alt="">
                    <div style="padding: 1px 2px;flex: 1;">
                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;margin-top:7px">{{ item.answer }}</span>
                    </div>
                </div>
            </div>
            <div style="width:44px;height:44px;border-radius:22px;background:rgba(42, 130, 228, 1);position:fixed;right:10px;bottom:10px;box-shadow: 0px 4px 23px 0px rgba(42, 130, 228, 0.24);text-align:center;line-height:50px;" @click="phoneChat">
                <a-icon style="font-size:22px;color:rgba(255, 255, 255, 1)" type="message" />
            </div>
        </div>
        <div v-if="chatStylePhone" class="chat-phone" style="width:100%;height:100%;background:rgba(250, 250, 250, 1);position: relative;display:flex;flex-direction:column">
            <div style="height:52px;background:#fff;padding:12px 16px;position:relative;text-align:center;line-height:28px;">
                <a-icon style="position:absolute;left:16px;top:16px;color:rgba(18, 18, 18, 1);font-size:18px;" type="close" @click="closePhoneChat" />
                <span style="color:rgba(18, 18, 18, 1);font-size:16px;">对话</span>
            </div>
            <div style="flex:1;overflow-y:auto;padding:16px" id="chatBody">
                <div v-for="(item,index) in chatData" :key="index">
                    <div class="chat-gpt-phone" v-if="item.question!=''">
                        <img style="width:32px;border-radius:10px;height:32px;" src="./../assets/img/step-avator.png" alt="">
                        <div style="flex:1;margin:0 8px;border:1px solid rgba(229, 231, 235, 1);background:rgba(244, 244, 245, 0.5);border-radius:8px;color:rgba(18, 18, 18, 1);font-size:13px;padding:8px;word-break:break-all">
                            {{item.question}}
                        </div>
                        <!-- <a-icon @click="tryListen(item.question,index)" style="color:rgba(34, 215, 187, 1);font-size:18px;cursor:pointer;position:absolute;right:-24px;top:50%;margin-top:-10px;" type="play-circle" /> -->
                        <a-icon v-if="!item.ifPlay" @click="tryListen(item.question,index)" style="color:rgba(34, 215, 187, 1);font-size:18px;cursor:pointer;position:absolute;right:-24px;top:50%;margin-top:-10px;" type="play-circle" />
                        <a-icon v-if="item.ifPlay" style="color:rgba(34, 215, 187, 1);font-size:18px;cursor:pointer;position:absolute;right:-24px;top:50%;margin-top:-10px;" type="pause-circle" />
                    </div>
                    <span v-if="item.question==''" class="chat-loading-phone">
                        <a-icon class="gpt-icon" type="loading" />正在输入中...
                    </span>
                    <div style="clear:both;"></div>
                    <div class="chat-user-phone" v-if="item.answer!=''">
                        {{item.answer}}
                    </div>
                    <div style="clear:both"></div>
                </div>
                <div v-if="tryBiographicalBool" class="chat-error" style="margin-top:12px;">
                    <span @click="sendDataToBiographical" style="color:rgba(42, 130, 228, 1);cursor:pointer;margin-left:40px;text-decoration:underline">太慢啦，快些输入吧</span>
                </div>
            </div>
            <div style="height:68px;padding:11px 17px 0;display:flex;background:rgba(244, 244, 245, 0.5)">
                <a-input v-model="biographicalData" style="flex:1;height:47px;" placeholder="请输入" />
                <span @click="chatToBiographical(1)" style="display:inline-block;width:60px;height:47px;border-radius:6px;background:rgba(34, 215, 187, 1);font-size:14px;text-align:center;line-height:47px;margin-left:8px;color:#fff;">发送</span>
            </div>
        </div>
        <audio id="music2" style="display:none" controls autoplay :src="voiceUrl"></audio>
        <audio id="music3" style="display:none" controls :src="voiceUrl2"></audio>
        <audio id="music4" style="display:none" controls :src="voiceUrl3"></audio>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteModal" footer='' width='480px' title="删除数据">
            <div>
                <div>
                    <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:20px;" />
                    <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">删除后，数据无法恢复</span>
                </div>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelDelete">取消</a-button>
                    <a-button type="primary" @click="sureDelete" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="failModal" footer='' width='480px' title="操作失败">
            <div>
                <div>
                    <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:20px;" />
                    <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">对话模式下无法操作</span>
                </div>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelFail">取消</a-button>
                    <a-button type="primary" @click="sureFail" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="delDataModal" footer='' width='480px' title="删除数据">
            <div>
                <div>
                    <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:20px;" />
                    <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">关闭弹窗会清除对话记录？</span>
                </div>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelDelData">取消</a-button>
                    <a-button type="primary" @click="sureDelData" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="basicInfoModal" footer='' width='480px' title="基本信息新增">
            <div>
                <div style="color:rgba(80, 80, 80, 1);font-size:14px">
                    请选择新增的字段：
                </div>
                <a-select placeholder="请选择字段" v-model="currentSelectWord" style="width: 100%;margin-top:12px;" @change="handleChange">
                    <a-select-option :value="item" v-for="(item,index) in basicInfoWordList" :key="index">
                        {{item}}
                    </a-select-option>
                </a-select>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelBasicInfo">取消</a-button>
                    <a-button type="primary" @click="sureDelBasicInfo" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="screenModal" title="外链分享" footer='' width='720px'>
            <div class="share-modal modal-public">
                <div class="copy-link">
                    <a-input id="copyHtml1" readonly="readonly" :placeholder="linkUrl" />
                    <span @click="copyLink()">复制链接</span>
                </div>
            </div>
        </a-modal>
    </div>
</template>
  
<script>
    export default {
        name: 'Gpt',
        props: {
            msg: String
        },
        data() {
            return {
                projectId: '',
                currentStep: 0,
                chatList: [],
                deleteModal: false,
                failModal: false,
                addModal: false,
                delDataModal: false,
                basicInfoModal: false,
                readOnly: false,
                shareSwitch: false,
                chatSwitch: true,
                chatData: [],
                ifShowChat: false,
                gptName: '',
                jobTplList: [],
                tplId: '',
                step1Detail: {
                    name: '请选择职业背景',
                    des: '解释说明解释说明，解释说明解释说明，解释说明解释说明，解释说明解释说明，解释说明解释说明，......'
                },
                tplContent: '',
                disabledTpl: false,
                voiceUrl: '',
                biographicalDetail: '',
                basicInfoWordList: [],
                currentBasicWord: '',
                currentSelectWord: '',
                tryTplBool: false,
                jumpSource: '',
                biographicalData: '',
                disabledBiographical: false,
                tryBiographicalBool: false,
                ifOpenChat: true,
                screenModal: false,
                linkUrl: '',
                chatStylePhone: false,
                textData: [],
                voiceUrl2: '',
                voiceUrl3: '',
                currentIndex: 0,
                ifLast: false,
            }
        },
        methods: {
            cancelDelete() {
                this.deleteModal = false
            },
            sureDelete() {
                this.deleteModal = false
            },
            cancelFail() {
                this.failModal = false
            },
            sureFail() {
                this.failModal = false
            },
            cancelDelData() {
                this.delDataModal = false
            },
            sureDelData() {
                this.delDataModal = false
                this.ifShowChat = false 
                this.chatData = []
            },
            handleChange(value) {
                this.currentBasicWord = value
            },
            cancelBasicInfo() {
                this.basicInfoModal = false
            },
            sureDelBasicInfo() {
                if(this.currentSelectWord == ''){
                    this.$message.error('请选择新增字段')
                }else{
                    this.basicInfoModal = false
                    this.perfectBiographical(1, '', this.currentBasicWord, '')
                }
            },
            changeShare(checked) {
                this.shareSwitch = checked
                if(checked){
                    this.biographicalDetail.isShare = 1
                    this.changeShareState(1)
                }else{
                    this.biographicalDetail.isShare = 0
                    this.changeShareState(0)
                }
            },
            changeShareState(state) {
                this.axios.post('/api/assistant/shareResume', {
                    projectId: this.projectId,
                    status: state
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryBiographicalDel()
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeChat(checked) {
                this.chatSwitch = checked
                if(checked){
                    this.biographicalDetail.isOpenChat = 1
                    this.changeChatState(1)
                }else{
                    this.biographicalDetail.isOpenChat = 0
                    this.changeChatState(0)
                }
            },
            changeChatState(state) {
                this.axios.post('/api/assistant/openResumeChat', {
                    projectId: this.projectId,
                    status: state
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryBiographicalDel()
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            showChat() {
                if(this.chatSwitch){
                    this.ifShowChat = true
                    this.chatData = []
                    this.chatToBiographical()
                }else{
                    this.$message.error('该简历未开放对话权限')
                }
            },
            closeChat() {
                this.delDataModal = true
            },
            chatToBiographical(data) {
                if(data == 1){
                    this.chatData[this.chatData.length - 1]['answer'] = this.biographicalData
                }
                this.disabledBiographical = true
                this.biographicalData = ''
                setTimeout(()=>{
                    let obj = {}
                    obj.question = ''
                    obj.answer = ''
                    obj.ifPlay = false
                    this.chatData.push(obj)
                    this.scrollTopBody()
                })
                this.sendDataToBiographical()
            },
            playVoice(data) {
                // console.log(data)
                this.voiceUrl = 'http://47.111.165.100:8005/tts?text='+data+'&format=wav&speaker=47&voice=zh-CN-XiaochenNeural&speechRate=0&timestamp='+(new Date()).getTime()
            },
            playVoice2(data) {
                // console.log(data)
                this.voiceUrl2 = 'http://47.111.165.100:8005/tts?text='+data+'&format=wav&speaker=47&voice=zh-CN-XiaochenNeural&speechRate=0&timestamp='+(new Date()).getTime()
            },
            playVoice3(data) {
                // console.log(data)
                this.voiceUrl3 = 'http://47.111.165.100:8005/tts?text='+data+'&format=wav&speaker=47&voice=zh-CN-XiaochenNeural&speechRate=0&timestamp='+(new Date()).getTime()
            },
            replaceAll(str, find, replace) {
                return str.replace(new RegExp(find, 'g'), replace);
            },
            carryPlay() {
                let that = this
                for (let i = 0; i < this.textData.length; i++) {
                    (function (t) {
                        setTimeout(function () {
                            that.playVoice2(that.textData[i]['value'])
                        }, 500 * t);
                    })(i)
                }
                for(let i = 0; i < this.textData.length; i++){
                    if(this.textData[i]['flag'] == false){
                        this.textData[i]['flag'] = true
                        this.playVoice(this.textData[i]['value'])
                        return
                    }
                }
            },
            sendDataToBiographical() {
                this.tryBiographicalBool = false
                this.axios.post('/api/assistant/chatWithShareResume', {
                    projectId: this.projectId,
                    qaList: this.chatData
                })
                .then(response=> {
                    if(response.data.code == 0){
                        let that = this
                        let content = response.data.data.content
                        // this.voiceUrl = 'http://47.111.165.100:8005/tts?text='+content+'&format=wav&speaker=47&voice=zh-CN-XiaochenNeural&speechRate=0&timestamp='+(new Date()).getTime()
                        this.playVoice3(content)
                        let data2 = this.replaceAll(content, '。', '。@@')
                        let data3 = this.replaceAll(data2, '？', '？@@')
                        let data4 = this.replaceAll(data3, '；', '；@@')
                        let data5 = data4.split("@@")
                        this.textData = []
                        for(let i = 0; i < data5.length; i++){
                            let obj = {}
                            obj.flag = false
                            obj.value = data5[i]
                            if(data5[i]!=''){
                                this.textData.push(obj) 
                            }
                        }
                        this.carryPlay()
                        for (let i = 0; i < content.length; i++) {
                            (function (t) {   // 注意这里是形参
                                setTimeout(function () {
                                    that.chatData[that.chatData.length - 1]['question'] += content[t]
                                    that.scrollTopBody()
                                }, 75 * t);	// 还是每秒执行一次，不是累加的
                            })(i)   // 注意这里是实参，这里把要用的参数传进去
                        }
                        this.disabledBiographical = false
                        this.$nextTick(()=>{
                            this.$refs.binput.focus()
                        })
                    }else{
                        this.tryBiographicalBool = true
                        this.ifShowChat = false
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            scrollTopBody() {
                this.$nextTick(function() {
                    let div = document.getElementById('chatBody');
                    div.scrollTop = div.scrollHeight;
                })
            },
            tryListen(content,index) {
                this.voiceUrl = 'http://47.111.165.100:8005/tts?text='+content+'&format=wav&speaker=47&voice=zh-CN-XiaochenNeural&speechRate=0&timestamp='+(new Date()).getTime()
                // this.chatData[index]['ifPlay'] = true
                this.currentIndex = index
                for(let i = 0; i < this.chatData.length; i++){
                    if(i == index){
                        this.chatData[index]['ifPlay'] = true
                    }else{
                        this.chatData[i]['ifPlay'] = false 
                    }
                }
            },
            queryBiographicalDel() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/assistant/share', 
                        params: {
                            projectId: this.projectId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.biographicalDetail = response.data.data
                        if(response.data.data.isShare == 1){
                            this.shareSwitch = true
                        }else{
                            this.shareSwitch = false
                        }
                        if(response.data.data.isOpenChat == 1){
                            this.chatSwitch = true
                        }else{
                            this.chatSwitch = false
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            perfectBiographical(type, qaId, question, answer) {
                this.axios.post('/api/assistant/updateAssistant', {
                    projectId: this.projectId,
                    type: type,
                    qaId: qaId,
                    question: question,
                    answer: answer
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryBiographicalDel()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            shareModal() {
                let url = ''
                let protocol = window.location.protocol;
                let host = window.location.host;
                url = protocol + '//' + host + '/#/LiographicalLink?projectId=' + this.projectId
                this.linkUrl = url
                this.screenModal = true
            },
            copyLink() {
                let url = ''
                let protocol = window.location.protocol;
                let host = window.location.host;
                url = protocol + '//' + host + '/#/LiographicalLink?projectId=' + this.projectId
                let text = url
                let input = document.getElementById("copyHtml1");
                input.value = text; 
                input.select(); 
                document.execCommand("copy"); 
                this.$message.success('复制成功');
            },
            phoneChat() {
                this.chatData = []
                this.chatStylePhone = true
                this.chatToBiographical()
            },
            closePhoneChat() {
                this.chatData = []
                this.chatStylePhone = false
            }
        },
        mounted: function() {
            this.projectId = this.$route.query.projectId
            this.queryBiographicalDel()
           
            setTimeout(()=>{
                let that = this
                let Music2 = document.getElementById("music2")
                Music2.addEventListener('ended',function () {
                    that.carryPlay()
                    that.chatData[that.currentIndex]['ifPlay'] = false
                }, false)
            },1000)
            
        }
    }
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    ::-webkit-scrollbar {/*滚动条整体部分，其中的属性有width,height,background,border（就和一个块级元素一样）等。*/  
        width: 0px !important;  
        height: 0px !important;  
    }  
    .clean{
        clear: both;
    }
    .basic-info{
        .info-list{
            height: 35px;
            line-height: 35px;
            display: flex;
        }
        .info-title{
            display: inline-block;
            width: 70px;
            margin-right: 22px;
            text-align: left;
            color: rgba(158, 172, 196, 1);
            font-size: 13px;
        }
        .info-content{
            display: inline-block;
            // flex: 1;
            color: rgba(0, 0, 0, 1);
            font-size: 13px;
            margin-right: 12px;
            text-align: left;
            overflow: hidden;
        }
        .info-input{
            display: inline-block;
            flex: 1;
            color: rgba(0, 0, 0, 1);
            font-size: 13px;
            margin-right: 12px;
            text-align: left;
            overflow: hidden; 
        }
        .info-edit{
            color: rgba(34, 215, 187, 1);
            cursor: pointer;
            font-size: 14px;
            margin-left: 12px;
            margin-top: 10px;
            display: none;
        }
        .info-del{
            color: rgba(239, 67, 67, 1);
            cursor: pointer;
            font-size: 14px;
            margin-left: 16px;
            margin-top: 10px;
            display: none;
        }
        .info-off{
            color: rgba(158, 172, 196, 0.8);
            font-size: 13px;
            cursor: pointer;
            margin-right: 12px;
        }
        .info-sure{
            color: rgba(34, 215, 187, 1);
            font-size: 13px;
            cursor: pointer;
        }
        .info-list:hover{
            .info-edit{
                display: inline-block;
            }
            .info-del{
                display: inline-block;
            }
        }
    }
    .job-duty{
        .job-content{
            .job-edit{
                display: none;
                color: rgba(34, 215, 187, 1);
                font-size: 14px;
            }
        }
        .job-content:hover{
            .job-edit{
                display: inline-block;
            }
        }
    }
    .bg-info{
        .bg-list{
            .edit-bg{
                color:rgba(34, 215, 187, 1);
                font-size:14px;
                margin-right:16px;
                cursor:pointer;
                display: none;
            }
            .del-bg{
                color:rgba(239, 67, 67, 1);
                font-size:14px;
                cursor:pointer;
                display: none;
            }
            .off-bg{
                cursor: pointer;
                color: rgba(158, 172, 196, 0.8);
                font-size: 13px;
                margin-right: 12px;
            }
            .save-bg{
                cursor: pointer;
                color: rgba(34, 215, 187, 1);
                font-size: 13px;
            }
        }
        .bg-list:hover{
            .edit-bg{
                display: inline-block;
            }
            .del-bg{
                display: inline-block;
            }
        }
    }
    .extra-require{
        .extra-list{
            .edit-extra{
                color:rgba(34, 215, 187, 1);
                font-size:14px;
                margin-right:16px;
                cursor:pointer;
                display: none;
            }
            .del-extra{
                color:rgba(239, 67, 67, 1);
                font-size:14px;
                cursor:pointer;
                display: none;
            }
            .off-extra{
                cursor: pointer;
                color: rgba(158, 172, 196, 0.8);
                font-size: 13px;
                margin-right: 12px;
            }
            .save-extra{
                cursor: pointer;
                color: rgba(34, 215, 187, 1);
                font-size: 13px;
            }
        }
        .extra-list:hover{
            .edit-extra{
                display: inline-block;
            }
            .del-extra{
                display: inline-block;
            }
        }
    }
    .chat-gpt{
        float: left;
        max-width: 70%;
        margin-top: 12px;
        display: flex;
        position: relative;
    }
    .chat-loading{
        line-height: 32px;
        float: left;
        color: rgba(158, 172, 196, 1);
        i{
            margin: 0 8px;
        }
    }
    .chat-user{
        display: inline-block;
        padding: 8px;
        float: right;
        background: rgba(34, 215, 187, 0.08);
        border: 1px solid rgba(229, 231, 235, 1);
        border-radius: 8px;
        color: rgba(18, 18, 18, 1);
        font-size: 13px;
        margin-top: 12px;
    }
    .copy-link{
        height: 62px;
        input{
            width: 464px;
            float: left;
            height: 40px;
        }
        span{
            float: left;
            display: inline-block;
            width: 88px;
            height: 40px;
            border: 1px solid rgba(121, 136, 155, 0.3);
            cursor: pointer;
            border-radius: 0px 4px 4px 0px;
            line-height: 40px;
            text-align: center;
        }
    }
    .device-phone{
        display: none;
    }
    @media screen and (max-width: 640px) {
        .device-pc{
            display: none;
        }
        .device-phone{
            display: block;
        }
        .chat-gpt-phone{
            float: left;
            max-width: 80%;
            margin-top: 12px;
            display: flex;
            position: relative;
        }
        .chat-loading-phone{
            line-height: 32px;
            float: left;
            color: rgba(158, 172, 196, 1);
            i{
                margin: 0 8px;
            }
        }
        .chat-user-phone{
            display: inline-block;
            padding: 8px;
            float: right;
            background: rgba(34, 215, 187, 0.08);
            border: 1px solid rgba(229, 231, 235, 1);
            border-radius: 8px;
            color: rgba(18, 18, 18, 1);
            font-size: 13px;
            margin-top: 12px;
            max-width: 80%;
        }
    }
</style>
  